import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40dd25a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "micro-row table-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Authors", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Context", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Link", -1))
const _hoisted_5 = {
  key: 0,
  class: "table-body"
}

import { inject, onMounted, ref } from 'vue'
import PaperRow from '@/components/Papers/PaperRow.vue'


export default {
  __name: 'PapersView',
  setup(__props) {

const axios = inject('axios')

const papers = ref([])
const reloadTable = ref(0)
const sortKey = ref('date')
const sortOrder = ref(-1)

function sortTable (key, order) {
  sortKey.value = key
  sortOrder.value = order
  papers.value.sort((x, y) => {
    if (x[key] > y[key]) return order * 1
    if (x[key] < y[key]) return order * -1
    return 0
  })
  reloadTable.value++
}

onMounted(() => {
  axios.get('/api/literature')
    .then((d) => {
      papers.value = d.data
      sortTable(sortKey.value, sortOrder.value)
    })
    .catch(err => console.log(err))
})

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => (sortTable('date', sortKey.value !== 'date' ? -1 : sortOrder.value*-1)))
      }, [
        _createVNode(_component_unicon, { name: "sort" }),
        _createTextVNode(" Date ")
      ]),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => (sortTable('title', sortKey.value !== 'title' ? 1 : sortOrder.value*-1)))
      }, [
        _createVNode(_component_unicon, { name: "sort" }),
        _createTextVNode(" Title ")
      ]),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    (papers.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(papers.value.entries(), ([index, row]) => {
            return (_openBlock(), _createBlock(PaperRow, {
              key: `${index}-${reloadTable.value}`,
              paper: row
            }, null, 8, ["paper"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}